import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const OTPComparison = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to step 1 of comparison
    navigate("/app/otp/otp-comparison/step1", { replace: true });
  }, [navigate]);

  return null; // This component just redirects, so no UI needed
};

export default OTPComparison;
